import { useContext } from "react"
import { GStore } from "../context/Context"

export const ConvertEnglish = ({english , bangla}) =>{
    const {english:convertEnglish} = useContext(GStore)
    const result = convertEnglish ?english :bangla;
    return <>
        {result}
    </>
            
}

